import * as React from "react";
import type { VariantProps } from "class-variance-authority";

import { ButtonGroup } from "@vega-core/components/shadcn/button-group";
import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

import { SplitButtonContext } from "./SplitButtonContext";
import { type splitButtonVariants } from "./splitButtonVariants";
import { type SplitButtonVariant } from "./types";

export type SplitButtonRootProps = React.ComponentPropsWithoutRef<
  typeof ButtonGroup
> &
  VariantProps<typeof splitButtonVariants> & {
    variant?: SplitButtonVariant;
  };

export const SplitButtonRoot = React.forwardRef<
  React.ElementRef<typeof ButtonGroup>,
  SplitButtonRootProps
>(({ children, className, variant = "primary", ...props }, ref) => {
  const contextValue = React.useMemo(() => ({ variant }), [variant]);

  return (
    <SplitButtonContext.Provider value={contextValue}>
      <ButtonGroup className={cnTwMerge(className)} ref={ref} {...props}>
        {children}
      </ButtonGroup>
    </SplitButtonContext.Provider>
  );
});
